import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, message } from 'antd';
import './style.scss';
import { setBluetooth } from '../../store/speakerSlice';
import Base64Util from '../../utils/base64-util.js'
import useBluetooth from '../../hooks/useBluetooth.js'

// 蓝牙服务和特征值UUID
const SERVICE_UUID = "bb37a001-b922-4018-8e74-e14824b3a638";
const CHARACTERISTIC_UUID_RX = "bb37a002-b922-4018-8e74-e14824b3a638";
const CHARACTERISTIC_UUID_TX = "bb37a003-b922-4018-8e74-e14824b3a638";
let message_buffer = new Uint8Array();
const Bluetooth = () => {
    const dispatch = useDispatch();
    const bluetooth = useSelector(state => state.speaker.bluetooth);

    const [messageInput, setMessageInput] = useState('');
    const { connect, disconnect, sendMessage, receivedMessages } = useBluetooth();
    const connectBluetooth = async () => {
        try {
            const device = await connect();
            if (device) {
                // message.success('蓝牙设备连接成功');
            }
        } catch (error) {
            console.error('蓝牙连接失败:', error);
            // message.error('蓝牙连接失败');
        }
    }

    const disconnectBluetooth = async () => {
        try {
            await disconnect();
            message.success('蓝牙设备断开连接');
        } catch (error) {
            console.error('蓝牙断开连接失败:', error);
            message.error('蓝牙断开连接失败');
        }
    }

    const sendData = async () => {
        console.log('messageInput', messageInput)
        sendMessage(messageInput);
    }

    return (
        <div className="bluetooth">
            <div className="name">蓝牙通信</div>
            <div className="content">
                <div className="control-panel">
                    {!bluetooth ? (
                        <Button type="primary" onClick={connectBluetooth}>连接蓝牙设备</Button>
                    ) : (
                        <Button danger onClick={disconnectBluetooth}>断开连接</Button>
                    )}
                </div>

                <div className="message-panel">
                    <div className="received-messages">
                        <h3>接收到的消息</h3>
                        <div className="message-list">
                            {receivedMessages.map((msg, index) => (
                                <div key={index} className="message-item">{msg}</div>
                            ))}
                        </div>
                    </div>

                    <div className="send-message">
                        <input
                            type="text"
                            value={messageInput}
                            onChange={(e) => setMessageInput(e.target.value)}
                            placeholder="输入要发送的内容"
                            disabled={!bluetooth}
                        />
                        <Button
                            type="primary"
                            onClick={sendData}
                            disabled={!bluetooth}
                        >
                            发送
                        </Button>
                    </div>
                </div>
            </div>
            <footer>
                <p>当前状态: {bluetooth ? '已连接' : '未连接'}</p>
            </footer>
        </div>
    );
};

export default Bluetooth;